import React from 'react';
import '../css/buttons.css'

export default function Button({ text, funct, target, modal }) {
    return <button type="button" data-target={"#" + target} data-toggle={modal ? 'modal' : null} className="btn-bgSAP mx-1 my-3" onClick={(e) => funct(e)}>{text}</button>
}